import { useEffect, useState } from 'react';

import Button from '@components/button/Button';
import { Category } from 'types/categoryInput';

import {
  INPUT_BASE_CLASSNAME,
  INPUT_FOCUS_CLASSNAME
} from '../../constants/common';

interface EditCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (category: Category) => void;
  editingItem: Category | null;
  labelName?: string;
}

const EditCategoryModal = ({
  isOpen,
  onClose,
  onSave,
  editingItem: category,
  labelName = 'Category'
}: EditCategoryModalProps) => {
  const [categoryName, setCategoryName] = useState(category?.name || '');

  useEffect(() => {
    if (category) {
      setCategoryName(category.name || '');
    }
  }, [category]);

  const handleSave = () => {
    if (category && categoryName.trim()) {
      onSave({ ...category, name: categoryName.trim() });
      onClose();
    }
  };

  const handleCancel = () => {
    setCategoryName(category?.name || '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      data-edit-modal
    >
      <div className="w-[400px] max-w-[90vw] rounded-xl bg-theme p-6 shadow-lg">
        <div className="flex flex-col gap-4">
          <span className="text-base font-semibold">{labelName}</span>
          <input
            type="text"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter category name..."
            className={`w-full rounded-lg px-4 py-3 text-sm placeholder:text-cofeeNeutralInactive ${INPUT_BASE_CLASSNAME} ${INPUT_FOCUS_CLASSNAME}`}
          />
          <div className="flex items-center gap-3">
            <Button
              variant="tertiary"
              label="Cancel"
              handleClick={handleCancel}
              className="flex-1"
            />
            <Button
              variant="primary"
              label="Save"
              handleClick={handleSave}
              disabled={!categoryName.trim()}
              className="flex-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategoryModal;
